import { DefaultStorageKeys, StorageManager } from '@speeki/storage-manager';

//remember to add here all hotspot keys
interface HotspotKeys extends Pick<DefaultStorageKeys, 'hideDashboardHint'> {}

export class HotspotSevice {
    static setStorageHotspot = (key: keyof HotspotKeys, value: string) =>
        StorageManager.setValue(key, value);

    static removeStorageHotspot = (key: keyof HotspotKeys) =>
        StorageManager.removeValue(key);
}
